import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { ProfileContext } from "../context/ProfileContext";
import { IonIcon, IonTabBar, IonTabButton, IonLabel, IonBadge } from "@ionic/react";
import { WerkerJobContext } from "../context/JobContextWerker";
import { SchedJobContext } from "../context/JobContextScheduler";

import {
  albumsOutline,
  chatboxOutline,
  globeOutline,
  notificationsOutline,
  peopleOutline,
  personOutline,
} from "ionicons/icons";

const TabNavigator: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const blurFocusedElement = () => {
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement && activeElement !== document.body) {
      activeElement.blur();
    }
  };
  
  // Debug: log current path
  // console.log('TabNavigator - Current path:', currentPath);
  
  const { profilePicBadge, badgeCountAssociateRequestsContext, badgeCountDMContext, badgeCountAnnouncementsContext } =
    useContext(ProfileContext);

  const { badgeCountHeaderToggleWerkerContext } = useContext(WerkerJobContext);
  const { badgeCountHeaderToggleSchedulerContext } = useContext(SchedJobContext);
  const { badgeCountNotificationsContext, badgeCountPaymentReceiptsContext } = useContext(ProfileContext);

  const messageBadgeCount = badgeCountDMContext + badgeCountAnnouncementsContext;
  const notificationsBadgeCount = badgeCountNotificationsContext + badgeCountPaymentReceiptsContext;

  // Check if a tab is active (case-insensitive)
  const isActive = (path: string) => currentPath.toLowerCase() === path.toLowerCase();

  return (
    <React.Fragment>
      {/* <br /> */}
      <IonTabBar
        slot="bottom"
      >
        <IonTabButton tab="Chats" href="/Chats" onClick={blurFocusedElement}>
          <IonIcon
            icon={globeOutline}
            style={isActive('/Chats') ? { color: 'var(--ion-color-primary)' } : {}}
          />
          <IonLabel style={isActive('/Chats') ? { color: 'var(--ion-color-primary)' } : {}}>
            Comms
          </IonLabel>
          {messageBadgeCount > 0 && (
            <IonBadge
              color="danger"
            >
              {messageBadgeCount}
            </IonBadge>
          )}
        </IonTabButton>

        <IonTabButton tab="Community" href="/Associates" onClick={blurFocusedElement}>
          <IonIcon
            icon={peopleOutline}
            style={isActive('/Associates') ? { color: 'var(--ion-color-primary)' } : {}}
          />
          <IonLabel style={isActive('/Associates') ? { color: 'var(--ion-color-primary)' } : {}}>
            Associates
          </IonLabel>
          {badgeCountAssociateRequestsContext > 0 && (
            <IonBadge
              color="danger"
            >
              {badgeCountAssociateRequestsContext}
            </IonBadge>
          )}
        </IonTabButton>

        <IonTabButton tab="Home" href="/Home" onClick={blurFocusedElement}>
          <IonIcon
            icon={albumsOutline}
            style={isActive('/Home') ? { color: 'var(--ion-color-primary)' } : {}}
          />
          <IonLabel style={isActive('/Home') ? { color: 'var(--ion-color-primary)' } : {}}>
            Werk
          </IonLabel>
          {badgeCountHeaderToggleWerkerContext + badgeCountHeaderToggleSchedulerContext > 0 && (
            <IonBadge
              color="danger"
            >
              {badgeCountHeaderToggleWerkerContext + badgeCountHeaderToggleSchedulerContext}
            </IonBadge>
          )}
        </IonTabButton>

        <IonTabButton tab="Notifications" href="/Notifications" onClick={blurFocusedElement}>
          <IonIcon
            icon={notificationsOutline}
          />
          <IonLabel>
            Notifications
          </IonLabel>
          {notificationsBadgeCount > 0 && (
            <IonBadge
              color="danger"
            >
              {notificationsBadgeCount}
            </IonBadge>
          )}
        </IonTabButton>

        <IonTabButton tab="Profile" href="/Profile" onClick={blurFocusedElement}>
          <IonIcon
            icon={personOutline}
            style={isActive('/Profile') ? { color: 'var(--ion-color-primary)' } : {}}
          />
          <IonLabel style={isActive('/Profile') ? { color: 'var(--ion-color-primary)' } : {}}>
            Profile
          </IonLabel>
          {profilePicBadge === 1 && (
            <IonBadge
              color="danger"
            >
              {profilePicBadge}
            </IonBadge>
          )}
        </IonTabButton>
      </IonTabBar>
    </React.Fragment>
  );
};

export default React.memo(TabNavigator);
